import { useProcurifyIntl } from '@webapp/hooks'
import { type OrderItemStatus, OrderItemStatuses } from '@webapp/models/enums'
import messages from './messages'

export function useFormatOrderItemStatus() {
  const intl = useProcurifyIntl()

  return (status: OrderItemStatus): string => {
    switch (status) {
      case OrderItemStatuses.PENDING:
        return intl.formatMessage(messages.statusPending)
      case OrderItemStatuses.PENDING_PURCHASE:
        return intl.formatMessage(messages.statusPendingPurchase)
      case OrderItemStatuses.APPROVED:
        return intl.formatMessage(messages.statusApproved)
      case OrderItemStatuses.PURCHASED:
        return intl.formatMessage(messages.statusPurchased)
      case OrderItemStatuses.RECEIVED:
        return intl.formatMessage(messages.statusReceived)
      case OrderItemStatuses.REJECTED:
        return intl.formatMessage(messages.statusRejected)
      case OrderItemStatuses.PARTIALLY_RECEIVED:
        return intl.formatMessage(messages.statusPartiallyReceived)
      case OrderItemStatuses.DENIED:
        return intl.formatMessage(messages.statusDenied)
      case OrderItemStatuses.DRAFT:
        return intl.formatMessage(messages.statusDraft)
      default:
        return
    }
  }
}
